const c = (e, ...r) => r.reduce((o, t) => o.replace(/:\w+/, t), e);
export {
  c as routeFor
};
